import pages from './pages'
import forms from './forms'
import options from './options'
import map from './map'

export default {
  pages: pages,
  forms: forms,
  options: options,
  el: {
    pagination: {
      total: 'Total {total}',
      pagesize: '/page'
    },
    select: {
      noData: 'No data'
    }
  },
  map: map
}



// WEBPACK FOOTER //
// ./src/lang/en_GB/index.js